import { useMemo } from 'react';
import { useRecoilValue } from 'recoil';
import DownloadIcon from '@mui/icons-material/Download';
import {
  prefixState,
  S3File,
  selectCocoonsState,
  selectModelsState,
  selectMorphedState,
  selectTiresState,
  selectWheelhousesState
} from 'features/file-browser/state/fileAtoms';
import { CustomButton } from 'shared/ui/CustomButton';
import { handleDownloadButtonClick } from '../utils/downloadButtonClick';

export const DownloadButton: React.FC = () => {
  const prefix = useRecoilValue(prefixState);
  const selectModels = useRecoilValue(selectModelsState);
  const selectCocoons = useRecoilValue(selectCocoonsState);
  const selectTires = useRecoilValue(selectTiresState);
  const selectWheelhouses = useRecoilValue(selectWheelhousesState);
  const selectMorphed = useRecoilValue(selectMorphedState);

  const filesToDownload = useMemo<S3File[]>(() => {
    switch (prefix) {
      case "model": return selectModels;
      case "cocoon": return selectCocoons;
      case "tire": return selectTires;
      case "wheelhouse": return selectWheelhouses;
      case "morphed": return selectMorphed;
      default: return [];
    }
  }, [prefix, selectModels, selectCocoons, selectTires, selectWheelhouses, selectMorphed]);

  const disable = filesToDownload.length === 0;

  return (
    <CustomButton
      sx={{ fontSize: '10px', width: '100%' }}
      size="small"
      onClick={() => handleDownloadButtonClick(filesToDownload)}
      startIcon={<DownloadIcon />}
      disabled={disable}
    >
      Download
    </CustomButton>
  );
};
